/**
 * Password strength checker
 * Shared between ChangePassword and ResetPassword components
 */
export const getPasswordStrength = (password) => {
  if (!password) return { strength: 0, label: "", color: "" };

  let strength = 0;
  if (password.length >= 8) strength++;
  if (password.length >= 12) strength++;
  if (/[a-z]/.test(password) && /[A-Z]/.test(password)) strength++;
  if (/[0-9]/.test(password)) strength++;
  if (/[^a-zA-Z0-9]/.test(password)) strength++;

  if (strength <= 2) return { strength: 1, label: "Weak", color: "#dc3545" };
  if (strength <= 3) return { strength: 2, label: "Medium", color: "#ffc107" };
  if (strength <= 4) return { strength: 3, label: "Strong", color: "#28a745" };
  return { strength: 4, label: "Very Strong", color: "#009689" };
};
